import React, { useMemo } from "react";
import {
  appendCurrency,
  formatAddressWithHtml,
  formatDate,
} from "helpers/generalUtils";
import classNames from "classnames";

const Invoice1 = ({
  data: {
    orderNo,
    orderDate,
    orderLines = [],
    userAddress = {},
    couponDisc,
    orderSp,
    deliveryCharges,
    totalOrderAmount,
  } = {},
}) => {
  const style = `
    body {
        margin: 5px;
        background: white;
    }
    .invoice * {
        font-size: 2.5vw;
        color: #626262;
    }

    .invoice hr {
        margin: 2vw 0;
        border: none;
        border-bottom: 1px solid #e7e7e7;
    }

    .invoice .table tr.line {
        border-bottom: 1px solid #ccc;
    }

    .invoice .table td {
        border: none;
    }

    .invoice .identity {
        margin-top: 10px;
        font-size: 1.1em;
        font-weight: 300;
    }

    .invoice .identity strong {
        font-weight: 600;
    }

    .row {
        display: table;
        width: 100%;
        margin: 1vw 0;
    }

    .col-6 {
        width: 50%;
        display: table-cell;
    }

    .invoice .invoice-header {
        margin: 3vw 0;
    }

    .logo-container {
        vertical-align: middle;
        text-align: center;
    }

    .logo-container img {
        width: 80%;
    }

    .invoice-title {
        text-align: end;
    }

    .invoice-title .invoice-title__no {
        font-size: 4vw;
        margin-bottom: 1vw;
        text-transform: uppercase
    }

    .order-summary {
        margin-top: 1vw;
    }

    .order-summary .order-summary__title {
        font-size: 4vw;
        margin: 2vw 0;
    }

    .order-summary-table {
        width: 100%;
        border-collapse: collapse;
    }

    .order-summary-table .first-row td {
        padding-top: 3vw;
    }

    .order-summary-table .last-row td {
        padding-bottom: 3vw;
        border-bottom: 1px solid #e7e7e7;
    }

    .order-summary-table td {
        padding: 1vw;
    }

    .order-summary-table .line {
        border-bottom: 1px solid #e7e7e7;
    }

    .order-summary-table .line td {
        padding: 2vw;
    }

    .text-center {
        text-align: center;
    }

    .text-right {
        text-align: end;
    }

    .text-bold {
        font-weight: bold;
    }

    .order-summary-table .product-title-column {
        width: 60vw;
    }

    .invoice-address {
      max-width: 50vw;
    }
  `;

  const totalQty = useMemo(() => {
    return orderLines.reduce((a, b) => a + b.qty, 0);
  }, [orderLines]);
  return (
    <div>
      <style>{style}</style>

      <div className="invoice">
        <div className="invoice-header row">
          <div className="logo-container col-6">%logo%</div>
          <div className="invoice-title col-6">
            <div className="invoice-title__no">{orderNo}</div>
            <div className="invoice-title__date">{formatDate(orderDate)}</div>
          </div>
        </div>
        <hr />
        <div className="row invoice-address">
          <strong>Billed To:</strong>
          {formatAddressWithHtml(userAddress)}
        </div>
        <div className="row">
          <div className="order-summary col">
            <div className="order-summary__title">ORDER SUMMARY</div>
            <table className="order-summary-table">
              <thead>
                <tr className="line">
                  <td>
                    <strong>#</strong>
                  </td>
                  <td className="text-center product-title-column">
                    <strong>Product name</strong>
                  </td>
                  <td className="text-center">
                    <strong>Qty</strong>
                  </td>
                  <td className="text-center">
                    <strong>Unit</strong>
                  </td>
                  <td className="text-center">
                    <strong>Price</strong>
                  </td>
                  <td className="text-right">
                    <strong>Subtotal</strong>
                  </td>
                </tr>
              </thead>
              <tbody>
                {orderLines.map(
                  ({ productName, qty, totalSp, unitSp, unit }, index) => (
                    <tr
                      key={`product-list-${index}`}
                      className={classNames({
                        "first-row": index === 0,
                        "last-row": index === orderLines.length - 1,
                      })}
                    >
                      <td>{index + 1}</td>
                      <td>{productName}</td>
                      <td className="text-center">{qty}</td>
                      <td className="text-center">{unit}</td>
                      <td className="text-center">{appendCurrency(unitSp)}</td>
                      <td className="text-right">
                        {appendCurrency(totalSp, true)}
                      </td>
                    </tr>
                  )
                )}
                <tr>
                  <td colSpan="2" className="text-bold">
                    Total
                  </td>
                  <td className="text-center">
                    <strong>{totalQty}</strong>
                  </td>
                  <td colSpan="3" className="text-right">
                    <strong>{appendCurrency(orderSp, true)}</strong>
                  </td>
                </tr>
                <tr>
                  <td colSpan="3"></td>
                  <td className="text-right">
                    <strong>Discount</strong>
                  </td>
                  <td colSpan="2" className="text-right">
                    <strong>{appendCurrency(couponDisc, true)}</strong>
                  </td>
                </tr>
                <tr>
                  <td colSpan="3"></td>
                  <td className="text-right">
                    <strong>Delivery Charges</strong>
                  </td>
                  <td colSpan="2" className="text-right">
                    <strong>{appendCurrency(deliveryCharges, true)}</strong>
                  </td>
                </tr>
                <tr>
                  <td colSpan="3"></td>
                  <td className="text-right">
                    <strong>Total</strong>
                  </td>
                  <td colSpan="2" className="text-right">
                    <strong>{appendCurrency(totalOrderAmount, true)}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Invoice1;
